export default __webpack_public_path__ + "static/media/corporate-tv.a4329409.svg";